function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Provides various test cases to check for the browser capabilities.
 * @example
 * import {browserCheck} from '@ta-interaktiv/browsercheck'
 *
 * if (browserCheck.isIOS) {
 *   // do something iOS-specific here
 * }
 *
 * if (browserCheck.isAndroid) {
 *   // do something Android-specific here
 * }
 */
export var browserCheck =
/*#__PURE__*/
function () {
  function browserCheck() {
    _classCallCheck(this, browserCheck);
  }

  _createClass(browserCheck, null, [{
    key: "isMobile",

    /**
     * Is the window width lower than 600px?
     * @returns {boolean}
     */
    get: function get() {
      return window.innerWidth < 600;
    }
    /**
     * Is the window width between 600 and 900px?
     * @returns {boolean}
     */

  }, {
    key: "isTablet",
    get: function get() {
      return window.innerWidth >= 600 && window.innerWidth < 900;
    }
    /**
     * Is the window width larger than 900px?
     * @returns {boolean}
     */

  }, {
    key: "isDesktop",
    get: function get() {
      return window.innerWidth >= 900;
    }
    /**
     * Does the User Agent string contain «iPhone» or «iPod»?
     * @returns {boolean}
     */

  }, {
    key: "isIPhone",
    get: function get() {
      return /i(Phone|Pod)/i.test(window.navigator.userAgent);
    }
    /**
     * Does the User Agent string contain «iPad»?
     * @returns {boolean}
     */

  }, {
    key: "isIPad",
    get: function get() {
      return /iPad/i.test(window.navigator.userAgent);
    }
    /**
     * Does the User Agent string contain one of «iPhone», «iPad», or «iPod»?
     * @returns {boolean}
     */

  }, {
    key: "isIOS",
    get: function get() {
      return browserCheck.isIPad || browserCheck.isIPhone;
    }
    /**
     * Does the User Agent string contain «Android»?
     * @returns {boolean}
     */

  }, {
    key: "isAndroid",
    get: function get() {
      return /Android/i.test(window.navigator.userAgent);
    }
    /**
     * Does the user agent string contain «app-ios-smartphone», as per iApp
     * user agent string specs.
     * @returns {boolean}
     */

  }, {
    key: "isIOSNativeApp",
    get: function get() {
      return /app-ios-smartphone/i.test(window.navigator.userAgent);
    }
    /**
     * Does the user agent string contain «app-android-smartphone», as per
     * iApp user agent string specs.
     * @returns {boolean}
     */

  }, {
    key: "isAndroidNativeApp",
    get: function get() {
      return /app-android-smartphone/i.test(window.navigator.userAgent);
    }
    /**
     * Returns whether this is either an iOS or Android smartphone-sized
     * native app.
     * @returns {boolean}
     */

  }, {
    key: "isNativeSmartphoneApp",
    get: function get() {
      return browserCheck.isIOSNativeApp || browserCheck.isAndroidNativeApp;
    }
    /**
     * Does the user agent string contain «app-ios-tablet»?
     * @returns {boolean}
     */

  }, {
    key: "isIOSNativeTabletApp",
    get: function get() {
      return /app-ios-tablet/i.test(window.navigator.userAgent);
    }
    /**
     * Doest the user agent string contain «app-android-tablet»?
     * @returns {boolean}
     */

  }, {
    key: "isAndroidNativeTabletApp",
    get: function get() {
      return /app-android-tablet/i.test(window.navigator.userAgent);
    }
    /**
     * Does the user agent suggest to be a native tablet app, either iOS or
     * Android?
     * @returns {boolean}
     */

  }, {
    key: "isNativeTabletApp",
    get: function get() {
      return browserCheck.isIOSNativeTabletApp || browserCheck.isAndroidNativeTabletApp;
    }
    /**
     * Is it one of the native apps, both smartphones and tablets.
     * @returns {boolean}
     */

  }, {
    key: "isNativeApp",
    get: function get() {
      return browserCheck.isNativeSmartphoneApp || browserCheck.isNativeTabletApp;
    }
    /**
     * Is it an Android native app, either tablet- or smartphone-sized?
     * @returns {boolean}
     */

  }, {
    key: "isAndroidApp",
    get: function get() {
      return browserCheck.isAndroidNativeApp || browserCheck.isAndroidNativeTabletApp;
    }
    /**
     * Is it an iOS native app, either tablet- or smartphone-sized?
     * @returns {boolean}
     */

  }, {
    key: "isIOSApp",
    get: function get() {
      return browserCheck.isIOSNativeApp || browserCheck.isIOSNativeTabletApp;
    }
  }]);

  return browserCheck;
}();
export default browserCheck;